import { useCopyRecordingMutation } from '@carboncopyco/data';
import type { IRecording } from '@carboncopyco/types';
import { notify } from '@carboncopyco/ui';
import { CopyAssetModal } from '../../../CopyAssetModal';

interface CopyCloneModalWithFoldersProps {
  organizationId: string;
  clone: IRecording;
  onClose: () => void;
  goToCopiedClone?: (
    cloneId: number,
    workspaceId: string,
    folderId: string
  ) => void;
}

export const CopyCloneModalWithFolders = ({
  onClose,
  organizationId,
  clone,
  goToCopiedClone,
}: CopyCloneModalWithFoldersProps) => {
  const [copyClone, { isLoading: isLoadingCopyClone }] =
    useCopyRecordingMutation();

  const cloneFolderId = String(clone.folderId);
  const cloneWorkspaceId = String(clone.workspaceId);

  return (
    <CopyAssetModal
      isLoading={isLoadingCopyClone}
      close={onClose}
      origin={{
        id: cloneFolderId,
        entity: cloneFolderId === '0' ? 'workspace' : 'folder',
        workspaceId: cloneWorkspaceId,
      }}
      onSubmit={({ assetName, folderId, workspaceId }) => {
        copyClone({
          organizationId,
          id: Number(clone.id),
          targetWorkspaceId: workspaceId,
          folderId: folderId,
          recordName: assetName,
        })
          .unwrap()
          .then(({ id, workspaceId, folderId }) => {
            goToCopiedClone?.(Number(id), workspaceId, folderId);
            notify.success('Clone was copied successfully');
          })
          .catch(() => {
            notify.error('Failed to copy clone');
          })
          .finally(() => {
            onClose();
          });
      }}
    />
  );
};
